<div class="blocBandeau">
  <ion-grid>
    <ion-row>
      @if (activiteEncours().type === 'ot') {
        <ion-col size="7" class="blocLibelle {{ activiteEncours().type_ot }}" (click)="clickActivite()">
          <span>{{ activiteEncours().libelle }}</span>
        </ion-col>
      } @else {
        <ion-col size="7" class="blocLibelle activite-interne" (click)="clickActivite()">
          <span>{{ activiteEncours().libelle }}</span>
        </ion-col>
      }
      @if (activiteEncours().type === 'ot') {
        <ion-col size="5" class="blocIconSti {{ activiteEncours().type_ot }}" (click)="clickActivite()">
          @if (activiteEncours().id_sti) {
            <ion-item class="bandeau_sti">
              <ion-label>
                {{ 'OT_DETAIL.STI_ASTREINTE.BADGE' | translate }}
                <ion-icon name="warning"></ion-icon>
              </ion-label>
            </ion-item>
          }
        </ion-col>
      } @else {
        <ion-col size="5" class="blocIconSti activite-interne" (click)="clickActivite()"></ion-col>
      }
    </ion-row>
  </ion-grid>
  <div class="item">
    <div class="left">
      <div class="item__blocText">
        <p
          class="item__blocText--text"
          [ngClass]="{
            deplacement_color: etatActivite() === 'En Déplacement',
            intervention_color: etatActivite() === 'En Intervention',
          }"
        >
          <small>{{ etatActivite() }}</small>
        </p>
        <p class="item__blocText--small">
          <small>{{ activiteEncours().site_name }}</small>
        </p>
      </div>
    </div>
    <div class="right item__buttons">
      <ion-button class="item__button more-button" (click)="onMoreClick()">
        <div class="item__button__icon">
          <ion-icon name="ellipsis-vertical"></ion-icon>
        </div>
      </ion-button>
    </div>
  </div>
</div>
